/* eslint-disable eqeqeq */
import React from 'react';
import {
  string,
  bool,
  number,
  func,
  oneOf,
  oneOfType,
} from 'prop-types';

import FormInputContainer from '../../../scaffolding/FormInputContainer/FormInputContainer';
import Input from '../../../Input';
import InputV2 from '../../../controls/InputV2/InputV2';

const InputWithLabel = ({
  id,
  label,
  value,
  required,
  title = '',
  placeholder,
  errorMsg = null,
  type = 'text',
  maxLength,
  onChange,
  autoComplete = null,
  version,
}) => {
  const VersionedInput = version === 1 ? Input : InputV2;

  return (
    <FormInputContainer id={`${id}_container`}>
      <label id={`${id}_label`} htmlFor={id}>
        {label}
      </label>

      <VersionedInput
        value={value}
        id={id}
        type={type}
        autoComplete={autoComplete}
        onChange={onChange}
        required={required}
        title={title}
        hasError={errorMsg?.length > 0}
        lengthMessage={`Limit of ${maxLength} characters reached`}
        hasMessage={value?.length == maxLength}
        errorMsg={errorMsg}
        placeholder={placeholder || title}
        maxLength={maxLength}
      />
    </FormInputContainer>
  );
};

InputWithLabel.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  value: string.isRequired,
  required: bool,
  title: string,
  placeholder: string,
  errorMsg: string,
  type: string,
  maxLength: number.isRequired,
  onChange: func.isRequired,
  autoComplete: oneOfType([string, bool]),
  version: oneOf([1, 2]),
};

InputWithLabel.defaultProps = {
  required: true,
  title: '',
  placeholder: '',
  errorMsg: null,
  type: 'text',
  autoComplete: null,
  version: 1,
};

export default InputWithLabel;
